import { render, staticRenderFns } from "./ShowHotRecord.vue?vue&type=template&id=0a07a0e3"
import script from "./ShowHotRecord.vue?vue&type=script&lang=js"
export * from "./ShowHotRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports